import React from 'react';
import UserProfileReportTable from '../../components/UserProfileReportTable';

const EmployeesProfileReportTable = () => (
  <UserProfileReportTable
    endpoint="users/employees"
    title="Employees Profile Report"
    exportName="Employees"
    emptyMessage="No employees found"
  />
);

export default EmployeesProfileReportTable;
